import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Results from './Results.js';
import ToolBar from './ToolBar.js';
import { PAGE_SIZE_LIST, STATUS_API } from 'src/app/constant/config';
import { getListUsers } from 'src/features/userSlice.js';
import { getListProvinces } from 'src/features/provinceSlice.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import { useQuery } from 'src/app/hooks/useQuery.js';

const UserTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const query = useQuery();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  const listUsers = useSelector(state => state.userSlice.listUsers);
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);

  const {
    statusCreate: statusCreateUser,
    statusDelete,
    statusUpdate,
    statusDeleteMultiUsers
  } = useSelector(state => state.userSlice);
  const { statusCreate: statusCreateCustomer } = useSelector(
    state => state.customerSlice
  );

  const params = useMemo(() => {
    return {
      page: Number(query.get('page')) || 1,
      citizen_id: query.get('citizen_id') || undefined,
      status: query.get('status') || undefined,
      keywords: query.get('keywords') || undefined,
      page_size: isMobile ? 6 : PAGE_SIZE_LIST
    };
  }, [query, isMobile]);

  useEffect(() => {
    dispatch(getListUsers(params));
  }, [params]);

  useEffect(() => {
    dispatch(getListProvinces());
  }, []);

  const updateQuery = nextParams => {
    navigate('/app/manage/users?' + _convertObjectToQuery(nextParams));
  };

  useEffect(() => {
    if (
      statusCreateUser === STATUS_API.SUCCESS ||
      statusCreateCustomer === STATUS_API.SUCCESS ||
      statusDelete === STATUS_API.SUCCESS ||
      statusUpdate === STATUS_API.SUCCESS ||
      statusDeleteMultiUsers === STATUS_API.SUCCESS
    ) {
      dispatch(getListUsers(params));
    }
  }, [
    statusCreateUser,
    statusCreateCustomer,
    statusDelete,
    statusUpdate,
    statusDeleteMultiUsers
  ]);

  return (
    <div className={classes.root}>
      <div style={{ width: '98%', margin: '0 auto' }}>
        <ToolBar
          searchRef={updateQuery}
          listProvinces={listProvinces}
        />
        <Results
          className="mt-3"
          listUsers={listUsers}
          getListUsersRef={updateQuery}
          currentParams={params}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    paddingTop: theme.spacing(2)
  }
}));

export default UserTable;
